<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">商品类型</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商品类型
      <small>定义商品类型及属性...</small>
    </h1>
    <!-- end page-header -->
    <panel title="商品类型列表" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add_type">
          <i class="fa fa-plus"></i> 新增类型
        </button>
      </div>
      <Table border size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit_priceattr(row,index)"
          >价格参数</button>
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit_attribute(row,index)"
          >类型参数</button>
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit(row,index)"
          >修改</button>

          <Poptip
            transfer
            v-if="row.attrcount == 0 && row.priceattrcount == 0"
            confirm
            title="是否要删除此类型以及对应的属性?"
            @on-ok="fn_remove(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">删除</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer title="商品类型" v-model="v_edit_type" width="720" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="类型名称" label-position="top" prop="type_name">
          <Input v-model="formData.type_name" placeholder="商品分类名称" />
        </FormItem>

        <FormItem label="状态" label-position="top">
          <Select v-model="formData.status">
            <Option :value="1">有效</Option>
            <Option :value="-1">无效</Option>
          </Select>
        </FormItem>

        <FormItem label="备注" label-position="top">
          <Input
            type="textarea"
            v-model="formData.remarks"
            :rows="4"
            placeholder="please enter the description"
          />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_type = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { storeTypeData, getTypeList, removeTypeData } from "@/api/goods";
export default {
  data() {
    return {
      columns: [
        {
          title: "商品分类名称",
          key: "type_name",
          width: 300
        },
        {
          title: "状态",
          slot: "status",
          width: 120
        },
        {
          title: "价格参数数量",
          key: "priceattrcount",
          width: 120
        },
        {
          title: "类型参数数量",
          key: "attrcount",
          width: 120
        },

        {
          title: "备注",
          key: "remarks"
        },
        {
          title: "操作",
          slot: "action",
          width: 280,
          align: "left"
        }
      ],
      data: [],
      formData: {
        id: 0,
        type_name: "",
        remarks: "",
        status: 1
      },
      rules: {
        type_name: [
          {
            required: true,
            message: "名称必填",
            tirgger: "blur"
          }
        ]
      },
      v_edit_type: false,
      totalRows: 0,
      pageNum: 10,
      currentPage: 1
    };
  },
  mounted() {
    let filterCond = {
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(filterCond);
  },
  methods: {
    fn_load_data(filterCond) {
      getTypeList(filterCond).then(res => {
        this.data = res.data.data;
        this.totalRows = res.data.total;
      });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_add_type() {
      this.v_edit_type = true;
      this.formData = {
        id: 0,
        type_name: "",
        remarks: "",
        status: 1
      };
    },
    fn_edit(row, index) {
      this.formData = row;
      this.v_edit_type = true;
    },
    fn_edit_attribute(row, index) {
      const route = {
        name: "goods_typeattribute",
        params: { data: row }
      };
      this.$router.push(route);
    },
    fn_edit_priceattr(row, index) {
      const route = {
        name: "goods_typepriceattr",
        params: { data: row }
      };
      this.$router.push(route);
    },
    fn_remove(row, index) {
      removeTypeData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_store_data() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeTypeData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                this.v_edit_type = false;
                this.data.push(res.data.data);
                this.$Notice.success(res.data);
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    }
  }
};
</script>